module.exports = __webpack_public_path__ + "media/images/iconLockClosed__accent--dark-e92ca75efb992f41b99a01eb3a8f1480.png";